/* tslint:disable */

declare var Object: any;
export interface TrayObjectInterface {
  "trayId": number;
  "objectId": number;
  "objectTypeId": number;
  "parentObjectId": number;
  "order"?: number;
  "active"?: boolean;
  "createdAt"?: Date;
  "createdBy"?: number;
  "updatedAt"?: Date;
  "updatedBy"?: number;
  "id"?: number;
}

export class TrayObject implements TrayObjectInterface {
  "trayId": number;
  "objectId": number;
  "objectTypeId": number;
  "parentObjectId": number;
  "order": number;
  "active": boolean;
  "createdAt": Date;
  "createdBy": number;
  "updatedAt": Date;
  "updatedBy": number;
  "id": number;
  constructor(data?: TrayObjectInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `TrayObject`.
   */
  public static getModelName() {
    return "TrayObject";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of TrayObject for dynamic purposes.
  **/
  public static factory(data: TrayObjectInterface): TrayObject{
    return new TrayObject(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'TrayObject',
      plural: 'TrayObjects',
      path: 'TrayObjects',
      idName: 'id',
      properties: {
        "trayId": {
          name: 'trayId',
          type: 'number'
        },
        "objectId": {
          name: 'objectId',
          type: 'number'
        },
        "objectTypeId": {
          name: 'objectTypeId',
          type: 'number'
        },
        "parentObjectId": {
          name: 'parentObjectId',
          type: 'number'
        },
        "order": {
          name: 'order',
          type: 'number'
        },
        "active": {
          name: 'active',
          type: 'boolean',
          default: true
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'number'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "updatedBy": {
          name: 'updatedBy',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
